'use client'

import React from 'react'
import Grid from '@mui/material/Grid'
import ExportListTable from './ExportListTable'
import ExportGrid from './ExportGrid'

const ExportList = ({
    viewMode,
    data,
    loading,
    totalRecords,
    currentPage,
    itemsPerPage,
    onPageChange,
    onItemsPerPageChange,
    onRefresh
}) => {
    return (
        <Grid container spacing={6} sx={{ width: '100%', maxWidth: 'none', m: 0, flexGrow: 1 }}>
            <Grid item xs={12} sx={{ p: '0 !important', width: '100%', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                {viewMode === 'table' ? (
                    <ExportListTable
                        data={data}
                        loading={loading}
                        totalRecords={totalRecords}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        onPageChange={onPageChange}
                        onItemsPerPageChange={onItemsPerPageChange}
                    />
                ) : (
                    <ExportGrid
                        data={data}
                        loading={loading}
                        onRefresh={onRefresh}
                    />
                )}
            </Grid>
        </Grid>
    )
}

export default ExportList
